'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, type FocusEventHandler } from 'react';
import { Input } from '@material-bank/mb3-components';
import { CountrySelector, usePhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
type PhoneInputProps = {
  value: string;
  onChange: (phone: string) => void;
  id?: string;
  placeholder?: string;
  required?: boolean;
  invalid?: boolean;
  describedBy?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
};
export function PhoneInput(t0) {
  const $ = _c(25);
  const {
    value,
    onChange,
    id,
    placeholder: t1,
    required: t2,
    invalid: t3,
    describedBy,
    onBlur
  } = t0;
  const placeholder = t1 === undefined ? "00 000 0000" : t1;
  const required = t2 === undefined ? false : t2;
  const invalid = t3 === undefined ? false : t3;
  const inputRef = useRef(null);
  let t4;
  if ($[0] !== onChange) {
    t4 = data => {
      const hasNationalNumber = /\d/.test(data.inputValue);
      onChange(hasNationalNumber ? data.phone : "");
    };
    $[0] = onChange;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t4 || $[3] !== value) {
    t5 = {
      defaultCountry: "us",
      value,
      disableDialCodeAndPrefix: true,
      onChange: t4,
      inputRef
    };
    $[2] = t4;
    $[3] = value;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    inputValue,
    handlePhoneValueChange,
    country,
    setCountry
  } = usePhoneInput(t5);
  const t6 = `flex items-center gap-1 rounded-[10px] border bg-background-input px-3 focus-within:ring-2 focus-within:ring-offset-2 ${invalid ? "border-destructive focus-within:ring-destructive" : "border-input focus-within:ring-ring"}`;
  let t7;
  if ($[5] !== setCountry) {
    t7 = countryData => setCountry(countryData.iso2);
    $[5] = setCountry;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: "24px",
      height: "24px",
      clipPath: "circle(36%)"
    };
    t9 = {
      className: "!z-50"
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== country.iso2 || $[10] !== t7) {
    t10 = <CountrySelector selectedCountry={country.iso2} onSelect={t7} buttonClassName="!border-none !bg-transparent !p-0 !h-auto" flagStyle={t8} dropdownStyleProps={t9} />;
    $[9] = country.iso2;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== describedBy || $[13] !== handlePhoneValueChange || $[14] !== id || $[15] !== inputValue || $[16] !== invalid || $[17] !== onBlur || $[18] !== placeholder || $[19] !== required) {
    t11 = <Input id={id} type="tel" ref={inputRef} value={inputValue} placeholder={placeholder} onChange={handlePhoneValueChange} onBlur={onBlur} variant="ghost" className="!ring-0 !ring-offset-0" aria-required={required} aria-invalid={invalid} aria-describedby={describedBy} />;
    $[12] = describedBy;
    $[13] = handlePhoneValueChange;
    $[14] = id;
    $[15] = inputValue;
    $[16] = invalid;
    $[17] = onBlur;
    $[18] = placeholder;
    $[19] = required;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t6) {
    t12 = <div className={t6}>{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}